"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuturesUsdmOrdersController = void 0;
const constants_1 = require("../config/constants");
const futuresUsdm_1 = require("../data/futuresUsdm");
const market_1 = require("../data/market");
const rest_1 = require("../network/rest");
const WsBinanceClient_1 = require("../network/WsBinanceClient");
const binance_1 = require("../types/binance");
const shared_1 = require("../utils/data/shared");
const futures_1 = require("../utils/dataMappers/futures");
const futures_2 = require("../utils/dataMappers/futures");
const formatted_1 = require("../utils/eventFilters/formatted");
const misc_1 = require("../utils/misc");
const shared_2 = require("./shared");
class FuturesUsdmOrdersController extends shared_2.OrdersController {
    constructor(params) {
        super(params);
        this.defaultSubscriptionPairs = [{
                pair: 'BTCUSDT',
                baseAsset: 'BTC',
                quoteAsset: 'USDT'
            }];
        this.createQuotePairs = (params) => {
            return (0, misc_1.createUsdtQuotePair)(params);
        };
        this.getBalances = (params) => __awaiter(this, void 0, void 0, function* () {
            return FuturesUsdmOrdersController.getBalances(params);
        });
        this.subscribeDueToData = (pairsToSubscribe, pairsToUnsubscribe) => {
            this.wsClient.unsubscribeMarkPriceStream(pairsToUnsubscribe.map(pair => pair.pair));
            this.wsClient.subscribeMarkPriceStream(pairsToSubscribe.map(pair => pair.pair));
        };
        const { ordersList, userBalance, exchangeInfo, restClient, symbolPriceTicker = [] } = params;
        this.marketTickers = symbolPriceTicker;
        this.marketDataInstance = new market_1.MarketDataFutures(Object.assign({ exchangeInfo }, (symbolPriceTicker.length > 0 ? {
            marketAssets: new Map(Object.entries((0, misc_1.priceTickerToMarketAsset)(symbolPriceTicker, exchangeInfo)))
        } : {})));
        userBalance.update({
            marketData: this.marketDataInstance.data
        });
        this.ordersList = ordersList;
        this.userBalance = userBalance;
        this.exchangeInfo = exchangeInfo;
        this.restClient = restClient;
    }
    setInitialSubscriptions() {
        //initial price subscription
        const pairsToSubscribe = this.createQuotePairs({
            assetIds: [...this.userBalance.assetIds, ...this.ordersList.positionsArray.map(position => {
                    return position.baseAsset;
                })],
            exchangeInfo: this.exchangeInfo
        });
        this.wsClient.subscribeMarkPriceStream(pairsToSubscribe.quotes.map(pair => pair.pair));
    }
    static load(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { wsParams, userBalance, restClientParams, cacheManager } = params;
            const [restClient] = yield Promise.all([
                rest_1.RestBinanceUsdmClient.load(restClientParams)
            ]);
            const [{ userBalanceFetched, exchangeInfo, ordersList, tickersPrice }, wsClient] = yield Promise.all([FuturesUsdmOrdersController.getInitialData(Object.assign({ restClient }, params)), WsBinanceClient_1.WsBinanceClient.load(wsParams)]);
            return new FuturesUsdmOrdersController({
                ordersList,
                wsClient,
                restClient,
                userBalance: userBalance || userBalanceFetched,
                exchangeInfo,
                symbolPriceTicker: tickersPrice,
                cacheManager
            });
        });
    }
    static getInitialData(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { restClient, ordersListParams, cacheManager } = params;
            let cachedData = undefined;
            if (cacheManager)
                cachedData = yield cacheManager.get(constants_1.CACHE_SELECTORS.usdmExchange);
            const exchangeInfo = cachedData ? cachedData : (yield restClient.getExchangeInfoRaw()).data;
            if (cacheManager && cachedData === undefined)
                yield cacheManager.set(constants_1.CACHE_SELECTORS.usdmExchange, exchangeInfo);
            const [ordersList, userBalances, tickersPrice] = yield Promise.all([futuresUsdm_1.FuturesUsdmOrderList.load(Object.assign(Object.assign({}, ordersListParams), { exchangeInfo: exchangeInfo, fetchOrders: () => __awaiter(this, void 0, void 0, function* () {
                        try {
                            const orders = yield restClient.getOpenOrdersRaw({});
                            return orders.data.map(futures_1.futuresOrderRawToFuturesOrderMapper);
                        }
                        catch (_b) {
                            return [];
                        }
                    }), fetchPositions: () => __awaiter(this, void 0, void 0, function* () {
                        const positions = yield restClient.getPositionInformationRaw({});
                        return positions.data.filter(position => {
                            return Number(position.positionAmt) !== 0;
                        }).map((position) => {
                            return (0, futures_2.futuresPositionRawToPosition)({
                                exchangeInfo: exchangeInfo,
                                positionRaw: position
                            });
                        });
                    }) })),
                FuturesUsdmOrdersController.getBalances({ restClient }),
                restClient.getSymbolPriceTicker()]);
            ordersList.update({
                totalMarginBalance: userBalances.raw.availableBalance
            });
            return {
                exchangeInfo: exchangeInfo,
                userBalanceFetched: userBalances.balances,
                ordersList,
                tickersPrice: tickersPrice.data
            };
        });
    }
    isHasUpdates(messages) {
        return {
            ordersMessages: [
                ...formatted_1.eventFormattedFiltersMap[binance_1.EWsBinanceFuturesEventTypes.ORDER_TRADE_UPDATE](messages),
                ...formatted_1.eventFormattedFiltersMap[binance_1.EWsBinanceFuturesEventTypes.ACCOUNT_UPDATE](messages)
            ]
        };
    }
    startPolling() {
        if (this.isFirstInit)
            this.pollingService.start([
                {
                    callback: () => __awaiter(this, void 0, void 0, function* () {
                        let accountInfo, positionsInfo;
                        try {
                            [accountInfo, positionsInfo] = yield Promise.all([
                                this.restClient.getAccountInformationRaw({}),
                                this.restClient.getPositionInformationRaw({})
                            ]);
                        }
                        catch (_b) {
                            return;
                        }
                        this.ordersList.update({
                            totalMarginBalance: accountInfo.data.availableBalance
                        });
                        this.ordersList.updateLiquidationPrice(positionsInfo.data);
                    }),
                },
                {
                    callback: () => __awaiter(this, void 0, void 0, function* () {
                        const adlQuantiles = yield this.restClient.getAdlQuantileEstimation();
                        try {
                            this.updateAdlQuantiles(adlQuantiles.data);
                        }
                        finally { }
                    }),
                    callImmediately: true,
                    timeout: constants_1.REQUEST_INTERVAL_ADL
                }
            ]);
        else
            this.pollingService.start([]);
    }
    updateExchageInfo(exchangeInfo) {
        this.exchangeInfo = exchangeInfo;
        this.ordersList.updateExchageInfo(exchangeInfo);
        this.marketDataInstance.updateUnknownSymbols(new Map(Object.entries((0, misc_1.priceTickerToMarketAsset)(this.marketTickers, exchangeInfo))));
        this.setInitialSubscriptions();
    }
    updateAdlQuantiles(adlQuantiles) {
        this.ordersList.updateAdlQuantile(adlQuantiles);
    }
    clearCache() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.delFromCache(constants_1.CACHE_SELECTORS.usdmExchange);
                return true;
            }
            catch (_b) {
                return false;
            }
        });
    }
    refreshCache() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.clearCache();
                const exchangeInfo = (yield this.restClient.getExchangeInfoRaw()).data;
                yield this.setToCache(constants_1.CACHE_SELECTORS.usdmExchange, exchangeInfo);
                this.updateExchageInfo(exchangeInfo);
                return true;
            }
            catch (_b) {
                return false;
            }
        });
    }
    getExchangeInfo() {
        return this.exchangeInfo;
    }
}
exports.FuturesUsdmOrdersController = FuturesUsdmOrdersController;
_a = FuturesUsdmOrdersController;
FuturesUsdmOrdersController.getBalances = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { restClient } = params;
    const accountInformation = yield restClient.getAccountInformationRaw({});
    return {
        balances: shared_1.FuturesDataUtils.createBalancesFromAccountInformation(accountInformation.data, {}),
        raw: accountInformation.data
    };
});
